import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import PageHeaders from '../../../Utils/PageHeaders';
import HubNav from '../../ResourceHubPages/HubNav/HubNav';
import NewsletterHeader from './components/NewsletterHeader';
import NewsletterSection from './components/NewsletterSection';

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: '40px',
  },
}));

const NewsletterPage = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <HubNav />
      <PageHeaders
        title="Free Retirement & 401k Newsletter — Weekly Insights | Plootus"
        description="Get Plootus's free weekly newsletter — retirement planning tips, 401k contribution updates, market insights, and personal finance strategies delivered to your inbox. Join thousands of subscribers."
        keywords="Plootus newsletters, financial insights, retirement planning, investment strategies, wealth growth"
        ogTitle="Join the Free Plootus Newsletter — Retirement Made Simple"
        ogDescription="Weekly retirement planning news and 401k strategies — free, concise, and expert-curated. Sign up in seconds."
        ogImage="Email/newsletter-themed brand image — a strong social share visual is especially important here since newsletter pages are often shared by subscribers"
        robots="Decision required: If the page is purely a sign-up form, consider noindex, follow to avoid a thin-content penalty. If Plootus publishes newsletter archives on this page (past issues), keep it indexable and treat it as a content hub — then it becomes a strong SEO asset."
        canonicalUrl="https://www.plootus.com/newsletter"
      />
      <NewsletterHeader />
      <NewsletterSection />
    </div>
  );
};

export default NewsletterPage;
